import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { EpaApi } from '../../../../services'
import { IPublicWaterSystem } from '../../../../types'

interface RequestOptions {
  pwsid: string,
  options?: AxiosRequestConfig
}

export const fetchPubWaterSystemAsync = createAsyncThunk<{}, RequestOptions>(
  'utilities/fetch',
  async ({ pwsid: id, options = {} }, { rejectWithValue }) => {
    try {
      const request = await EpaApi.getPubWaterSystem(id, options) as AxiosResponse<IPublicWaterSystem>

      return request.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchPubWaterSystemAsyncBuilder = (builder: any) => {
  builder.addCase(fetchPubWaterSystemAsync.fulfilled, (state, action) => {

    state.loading = false
    state.success = true
    state.data = action.payload
  })
  builder.addCase(fetchPubWaterSystemAsync.rejected, (state, action) => {
    state.loading = false
    state.success = false
    state.error = action.payload
  })
  builder.addCase(fetchPubWaterSystemAsync.pending, (state, action) => {
    state.loading = true
    state.success = false
    state.error = ''
  })
}